"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6203],{

/***/ 44609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ RepurchaseButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_breakpoints__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94698);
/* harmony import */ var styled_breakpoints__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(styled_breakpoints__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19521);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36357);
/* harmony import */ var _truck_anchor__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75689);
/* harmony import */ var _truck_button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48721);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: ",
        ";\n\n  ",
        " {\n    width: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  bottom: 0;\n  display: flex;\n  flex-direction: column-reverse;\n  padding: ",
        "px;\n  position: fixed;\n  width: 100%;\n  z-index: 10;\n\n  > a {\n    margin-top: ",
        "px;\n    text-align: center;\n  }\n\n  ",
        " {\n    align-items: center;\n    background-color: unset;\n    bottom: unset;\n    flex-direction: row;\n    justify-content: flex-end;\n    position: unset;\n\n    > a {\n      margin-right: ",
        "px;\n      margin-top: 0;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_truck_button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-9d34342f-0"
})(_templateObject(), function(props) {
    return props.loading ? "center" : "space-between";
}, (0,styled_breakpoints__WEBPACK_IMPORTED_MODULE_9__.up)("md"), function(props) {
    return props.theme.spacing.cozy * 37;
});
var Container = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-9d34342f-1"
})(_templateObject1(), function(props) {
    return props.theme.colors.grayLight;
}, function(props) {
    return props.theme.spacing.comfortable;
}, function(props) {
    return props.theme.spacing.comfortable;
}, (0,styled_breakpoints__WEBPACK_IMPORTED_MODULE_9__.up)("md"), function(props) {
    return props.theme.spacing.comfortable;
});
function RepurchaseButton(props) {
    var style = props.style, className = props.className, cartTotal = props.cartTotal, loading = props.loading;
    var disabled = !(0,lodash__WEBPACK_IMPORTED_MODULE_3__.isFinite)(cartTotal) || cartTotal === 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, {
        style: style,
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                href: "/",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_truck_anchor__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    $textStyle: "h5Semibold",
                    children: "Seguir comprando"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledButton, {
                loading: loading,
                type: "submit",
                color: "secondary",
                disabled: disabled,
                children: [
                    "Agregar al carrito",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Price */ .tA, {
                        value: cartTotal,
                        textStyle: "h5Semibold",
                        symbolTextStyle: "h5Semibold",
                        color: disabled ? "blackLight" : "white"
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 6203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U0": function() { return /* binding */ getSortedPairs; },
/* harmony export */   "cp": function() { return /* binding */ getCatalogParams; },
/* harmony export */   "iS": function() { return /* binding */ MostPurchasedContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66688);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88767);
/* harmony import */ var debug__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11227);
/* harmony import */ var debug__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(debug__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var toggled__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67866);
/* harmony import */ var _analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30588);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36357);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81251);
/* harmony import */ var _metrics__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11499);
/* harmony import */ var _truck_notifier__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5002);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(90644);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(13135);
/* harmony import */ var _button__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(44609);
/* harmony import */ var _elements__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(59596);
/* harmony import */ var _empty_states__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(85636);
/* harmony import */ var _header__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(38800);
/* harmony import */ var _line_item__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(80208);
/* harmony import */ var _use_on_submit__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(51858);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(58576);


























var logger = debug__WEBPACK_IMPORTED_MODULE_4___default()("sellers:repurchase:contents:most-purchased");
function getCatalogParams(orderQuery) {
    var ref;
    if (!orderQuery.isSuccess) {
        return null;
    }
    var skus = (0,lodash__WEBPACK_IMPORTED_MODULE_5__.map)((ref = orderQuery.data) === null || ref === void 0 ? void 0 : ref.data, "sku");
    if ((0,lodash__WEBPACK_IMPORTED_MODULE_5__.isEmpty)(skus)) {
        return null;
    }
    return {
        page: 1,
        sku: skus,
        limit: 10
    };
}
function getSortedPairs(catalogQuery, mostPurchasedQuery) {
    if (!catalogQuery.isSuccess || !mostPurchasedQuery.isSuccess) {
        return null;
    }
    return mostPurchasedQuery.data.data.map(function(purchasedItem) {
        var product = (0,lodash__WEBPACK_IMPORTED_MODULE_5__.find)(catalogQuery.data.data, {
            sku: purchasedItem.sku
        });
        if (!product) {
            return null;
        }
        return {
            purchasedItem: purchasedItem,
            product: product
        };
    }).filter(Boolean);
}
function getInitialValues(catalogQuery, mostPurchasedQuery) {
    if (!catalogQuery.isSuccess || !mostPurchasedQuery.isSuccess) {
        return null;
    }
    var sortedPairs = getSortedPairs(catalogQuery, mostPurchasedQuery);
    var lineItems = sortedPairs.map(function(sortedPair) {
        var product = sortedPair.product, purchasedItem = sortedPair.purchasedItem;
        return {
            sku: product.sku,
            price: product.price,
            stock: product.stock,
            disabled: Number(product.stock) === 0 || !(0,lodash__WEBPACK_IMPORTED_MODULE_5__.isNil)(product.minimumSalesQuantity) && Number(product.stock) < product.minimumSalesQuantity,
            purchasedTimes: purchasedItem.times,
            tierPricing: product.tierPricing
        };
    });
    var sortedCatalogItems = (0,lodash__WEBPACK_IMPORTED_MODULE_5__.map)(sortedPairs, "product");
    return {
        sortedCatalogItems: sortedCatalogItems,
        formValues: {
            lineItems: lineItems
        }
    };
}
function MostPurchasedContent(props) {
    var ref;
    var user = props.user;
    var vendor = (0,_hooks__WEBPACK_IMPORTED_MODULE_9__/* .useVendor */ .at)();
    var canHandleStock = (0,toggled__WEBPACK_IMPORTED_MODULE_6__/* .useFlag */ .P5)(_utils_constants__WEBPACK_IMPORTED_MODULE_13__/* .flags.HANDLE_STOCK */ .id.HANDLE_STOCK);
    var mostPurchasedQuery = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useQuery)("/account/purchased-products");
    var catalogParams = getCatalogParams(mostPurchasedQuery);
    var catalogQuery = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useQuery)([
        "/catalog/products",
        catalogParams
    ], {
        enabled: !!catalogParams
    });
    var mutateAsync = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useMutation)({}).mutateAsync;
    var initials = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return getInitialValues(catalogQuery, mostPurchasedQuery);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        catalogQuery.dataUpdatedAt,
        mostPurchasedQuery.dataUpdatedAt
    ]);
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), eventHasTriggered = ref1[0], setEventHasTriggered = ref1[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        var triggerViewItemListEvent = function() {
            var analyticsItems = (0,lodash__WEBPACK_IMPORTED_MODULE_5__.map)(initials.sortedCatalogItems, function(item) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({}, item), {
                    category: item.categories[0]
                });
            });
            _analytics__WEBPACK_IMPORTED_MODULE_7__/* .analytics.viewItemList */ .co.viewItemList(analyticsItems, _utils_constants__WEBPACK_IMPORTED_MODULE_13__/* .analyticsItemListContexts.MOST_PURCHASED_PRODUCTS */ .LO.MOST_PURCHASED_PRODUCTS);
            setEventHasTriggered(true);
        };
        if (!initials || eventHasTriggered) {
            return;
        }
        triggerViewItemListEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        initials
    ]);
    function onSubmit(formValues) {
        return _onSubmit.apply(this, arguments);
    }
    function _onSubmit() {
        _onSubmit = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(function(formValues) {
            var payload, error, error1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_25__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        payload = (0,_utils__WEBPACK_IMPORTED_MODULE_20__/* .getPayload */ .He)(formValues, user);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            _metrics__WEBPACK_IMPORTED_MODULE_10__/* .mixpanel.asyncTrack */ .H.asyncTrack(_utils_constants__WEBPACK_IMPORTED_MODULE_13__/* .events.PRODUCTS_ADDED_TO_CART_FROM_MOST_PURCHASED_PRODUCTS */ .U3.PRODUCTS_ADDED_TO_CART_FROM_MOST_PURCHASED_PRODUCTS, {
                                userId: user.originalId,
                                vendorSlug: vendor.slug,
                                vendorId: vendor.originalId
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        logger("Mixpanel tracking failed", error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        _state.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4,
                            mutateAsync({
                                endpoint: "/account/cart",
                                data: payload,
                                method: "PUT"
                            })
                        ];
                    case 5:
                        _state.sent();
                        _truck_notifier__WEBPACK_IMPORTED_MODULE_11__/* ["default"].success */ .Z.success("Productos agregados al carrito.");
                        (0,_utils__WEBPACK_IMPORTED_MODULE_12__/* .forceReloadTo */ .yQ)("/carrito");
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error1 = _state.sent();
                        _truck_notifier__WEBPACK_IMPORTED_MODULE_11__/* ["default"].error */ .Z.error("Hubo un error inesperado.");
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return _onSubmit.apply(this, arguments);
    }
    var decoratedOnSubmit = (0,_use_on_submit__WEBPACK_IMPORTED_MODULE_19__/* .useRepurchaseOnSubmit */ .h)(onSubmit);
    if (mostPurchasedQuery.isLoading || catalogQuery.isLoading) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_8__/* .Loader */ .nt, {});
    }
    var commonEmptyStateProps = {
        title: "Productos m\xe1s comprados"
    };
    if ((0,lodash__WEBPACK_IMPORTED_MODULE_5__.isEmpty)((ref = mostPurchasedQuery.data) === null || ref === void 0 ? void 0 : ref.data)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_empty_states__WEBPACK_IMPORTED_MODULE_16__/* .MostPurchasedNonExistent */ .BS, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({}, commonEmptyStateProps));
    }
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_20__/* .checkNotAvailableItems */ .Qn)(catalogQuery.data)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_empty_states__WEBPACK_IMPORTED_MODULE_16__/* .MostPurchasedNotAvailableItems */ .hc, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({}, commonEmptyStateProps));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_header__WEBPACK_IMPORTED_MODULE_17__/* .RepurchaseHeader */ .i, {
                title: commonEmptyStateProps.title,
                subtitle: "Revisa los productos que m\xe1s has comprado."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_2__/* .Form */ .l0, {
                initialValues: initials.formValues,
                onSubmit: decoratedOnSubmit,
                validate: function(formValues) {
                    return (0,_utils__WEBPACK_IMPORTED_MODULE_20__/* .onValidate */ .c4)(formValues, {
                        canHandleStock: canHandleStock
                    });
                },
                decorators: _utils_constants__WEBPACK_IMPORTED_MODULE_13__/* .defaultFinalFormDecorators */ .dn,
                children: function(formProps) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements__WEBPACK_IMPORTED_MODULE_15__/* .StyledForm */ .G, {
                        onSubmit: formProps.handleSubmit,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements__WEBPACK_IMPORTED_MODULE_15__/* .StyledContainer */ .P, {
                                children: (0,lodash__WEBPACK_IMPORTED_MODULE_5__.map)(initials.sortedCatalogItems, function(catalogProduct, index) {
                                    var purchasedTimes = formProps.values.lineItems[index].purchasedTimes;
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_line_item__WEBPACK_IMPORTED_MODULE_18__/* .RepurchaseLineItem */ .D, {
                                        fieldName: "lineItems[".concat(index, "].quantity"),
                                        catalogProduct: catalogProduct,
                                        purchasedTimes: purchasedTimes
                                    }, catalogProduct.id);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button__WEBPACK_IMPORTED_MODULE_14__/* .RepurchaseButton */ .N, {
                                loading: formProps.submitting,
                                cartTotal: (0,_utils__WEBPACK_IMPORTED_MODULE_20__/* .getCartTotal */ .I3)(formProps.values)
                            })
                        ]
                    });
                }
            })
        ]
    });
}


/***/ }),

/***/ 58576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "He": function() { return /* binding */ getPayload; },
/* harmony export */   "I3": function() { return /* binding */ getCartTotal; },
/* harmony export */   "Qn": function() { return /* binding */ checkNotAvailableItems; },
/* harmony export */   "c4": function() { return /* binding */ onValidate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var validate_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79765);
/* harmony import */ var validate_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(validate_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_product_shared__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95074);




function getCartTotal(formValues) {
    return (0,lodash__WEBPACK_IMPORTED_MODULE_0__.sum)(formValues.lineItems.filter(function(lineItem) {
        return !lineItem.disabled && (0,lodash__WEBPACK_IMPORTED_MODULE_0__.isNumber)(lineItem.quantity);
    }).map(function(lineItem) {
        return (0,_components_product_shared__WEBPACK_IMPORTED_MODULE_2__/* .getPriceFromTier */ .AZ)(lineItem) * Number(lineItem.quantity);
    }));
}
function checkNotAvailableItems(data) {
    return (0,lodash__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(data === null || data === void 0 ? void 0 : data.data);
}
function onValidate(formValues, flags) {
    var lineItems = formValues.lineItems.map(function(lineItem) {
        if (lineItem.disabled || !flags.canHandleStock) {
            return null;
        }
        var quantity = validate_js__WEBPACK_IMPORTED_MODULE_1___default().single(lineItem.quantity, {
            numericality: {
                lessThanOrEqualTo: lineItem.stock,
                notLessThanOrEqualTo: "%{count} disponible".concat(lineItem.stock > 1 ? "s" : "")
            }
        });
        if (!quantity) {
            return null;
        }
        return {
            quantity: quantity
        };
    });
    var errors = {
        lineItems: lineItems
    };
    if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.isEmpty)((0,lodash__WEBPACK_IMPORTED_MODULE_0__.compact)(lineItems))) {
        delete errors.lineItems;
    }
    return errors;
}
function getPayload(formValues, user) {
    // prettier-ignore
    var cartItemsQuantitiesBySku = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.fromPairs)(user.cart.lineItems.map(function(lineItem) {
        return [
            lineItem.product.sku,
            lineItem.quantity
        ];
    }));
    // prettier-ignore
    var formItemsQuantitiesBySku = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.fromPairs)(formValues.lineItems.filter(function(lineItem) {
        return !lineItem.disabled && lineItem.quantity > 0;
    }).map(function(lineItem) {
        return [
            lineItem.sku,
            lineItem.quantity
        ];
    }));
    var quantitiesBySku = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, cartItemsQuantitiesBySku, formItemsQuantitiesBySku);
    return (0,lodash__WEBPACK_IMPORTED_MODULE_0__.keys)(quantitiesBySku).map(function(key) {
        return {
            sku: key,
            quantity: quantitiesBySku[key]
        };
    });
}


/***/ }),

/***/ 59596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ StyledForm; },
/* harmony export */   "P": function() { return /* binding */ StyledContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_breakpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94698);
/* harmony import */ var styled_breakpoints__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(styled_breakpoints__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  margin-bottom: ",
        "px;\n\n  > *:not(:last-child) {\n    border-bottom: 1px solid ",
        ";\n  }\n\n  ",
        " {\n    flex: 1;\n    margin-bottom: 0;\n    overflow-x: auto;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bfe389a6-0"
})(_templateObject(), function(props) {
    return props.theme.spacing.cozy * 9 + props.theme.dimensions.buttonHeight;
}, function(props) {
    return props.theme.colors.gray;
}, (0,styled_breakpoints__WEBPACK_IMPORTED_MODULE_2__.up)("md"));
var StyledForm = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].form.attrs */ .ZP.form.attrs(function() {
    return {
        id: "repurchase-form"
    };
}).withConfig({
    componentId: "sc-bfe389a6-1"
})(_templateObject1());


/***/ }),

/***/ 85636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BS": function() { return /* binding */ MostPurchasedNonExistent; },
/* harmony export */   "FX": function() { return /* binding */ LastOrderNonExistent; },
/* harmony export */   "cC": function() { return /* binding */ LastOrderNotAvailableItems; },
/* harmony export */   "hc": function() { return /* binding */ MostPurchasedNotAvailableItems; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36357);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13135);
/* harmony import */ var _header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38800);







var commonProps = {
    actionProps: {
        route: "/",
        label: "Explorar tienda"
    }
};
function RepurchaseEmptyStateLayout(props) {
    var title = props.title, children = props.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_header__WEBPACK_IMPORTED_MODULE_4__/* .StyledContainer */ .P, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_header__WEBPACK_IMPORTED_MODULE_4__/* .RepurchaseHeader.Title */ .i.Title, {
                    children: title
                })
            }),
            children
        ]
    });
}
function LastOrderNonExistent(props) {
    var title = props.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RepurchaseEmptyStateLayout, {
        title: title,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .EmptyState */ .ub, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, commonProps), {
            image: _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .images.ILLUSTRATION_EMPTY_CART */ .Wc.ILLUSTRATION_EMPTY_CART,
            title: "A\xfan no has hecho tu primera compra",
            subtitle: "Los productos de tu \xfaltimo pedido aparecer\xe1n aqu\xed"
        }))
    });
}
function LastOrderNotAvailableItems(props) {
    var title = props.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RepurchaseEmptyStateLayout, {
        title: title,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .EmptyState */ .ub, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, commonProps), {
            image: _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .images.ILLUSTRATION_FILE_ALERT */ .Wc.ILLUSTRATION_FILE_ALERT,
            title: "Productos no disponibles",
            subtitle: "Puede que los productos de tu \xfaltimo pedido hayan sido despublicados o eliminados de la tienda"
        }))
    });
}
function MostPurchasedNonExistent(props) {
    var title = props.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RepurchaseEmptyStateLayout, {
        title: title,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .EmptyState */ .ub, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, commonProps), {
            image: _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .images.ILLUSTRATION_EMPTY_CART */ .Wc.ILLUSTRATION_EMPTY_CART,
            title: "A\xfan no has hecho tu primera compra",
            subtitle: "Los productos que m\xe1s compres aparecer\xe1n aqu\xed"
        }))
    });
}
function MostPurchasedNotAvailableItems(props) {
    var title = props.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RepurchaseEmptyStateLayout, {
        title: title,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_2__/* .EmptyState */ .ub, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, commonProps), {
            image: _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .images.ILLUSTRATION_FILE_ALERT */ .Wc.ILLUSTRATION_FILE_ALERT,
            title: "Productos no disponibles",
            subtitle: "Puede que los productos que m\xe1s has comprado hayan sido despublicados o eliminados de la tienda"
        }))
    });
}


/***/ }),

/***/ 38800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ StyledContainer; },
/* harmony export */   "i": function() { return /* binding */ RepurchaseHeader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _truck_label__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67734);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: ",
        "px;\n\n  > *:not(:last-child) {\n    margin-bottom: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3d659b1a-0"
})(_templateObject(), function(props) {
    return props.theme.spacing.comfortable;
}, function(props) {
    return props.theme.spacing.cozy;
});
function RepurchaseHeaderTitle(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_truck_label__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        as: "h1",
        $textStyle: "h4Semibold"
    }, props));
}
function RepurchaseHeader(props) {
    var title = props.title, subtitle = props.subtitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledContainer, {
        children: [
            typeof title === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RepurchaseHeaderTitle, {
                children: title
            }) : title,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_truck_label__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                as: "h2",
                $textStyle: "h6Regular",
                children: subtitle
            })
        ]
    });
}
RepurchaseHeader.Title = RepurchaseHeaderTitle;


/***/ }),

/***/ 80208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ RepurchaseLineItem; },
/* harmony export */   "W": function() { return /* binding */ RepurchaseLineItemImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66688);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(19521);
/* harmony import */ var toggled__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67866);
/* harmony import */ var _analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30588);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36357);
/* harmony import */ var _components_product_shared__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95074);
/* harmony import */ var _components_unit_tooltip__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(46341);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81251);
/* harmony import */ var _hooks_use_counter__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(43031);
/* harmony import */ var _truck_image__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(52679);
/* harmony import */ var _truck_theme__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(78904);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(90644);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(13135);
/* harmony import */ var _variables__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(93063);





function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  bottom: ",
        "px;\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  right: ",
        "px;\n  z-index: 1;\n\n  > span {\n    margin-top: ",
        "px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  align-self: center;\n  border: 1px solid ",
        ";\n  border-radius: ",
        "px;\n  display: flex;\n  overflow: hidden;\n  padding: ",
        "px;\n  position: relative;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  display: flex;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-shrink: 0;\n  padding: ",
        "px;\n  position: relative;\n\n  > *:not(:last-child) {\n    margin-right: ",
        "px;\n  }\n\n  > ",
        " {\n    flex: 1;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  background: ",
        ";\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-self: flex-end;\n  justify-content: flex-end;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 100%;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



















var InfoContainer = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d980fce7-0"
})(_templateObject());
var CounterContainer = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d980fce7-1"
})(_templateObject1(), function(props) {
    return props.theme.spacing.cozy * 3.25;
}, function(props) {
    return props.theme.spacing.cozy;
}, function(props) {
    return props.theme.spacing.compact;
});
var ImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d980fce7-2"
})(_templateObject2(), function(props) {
    return props.theme.colors.gray;
}, function(props) {
    return props.theme.spacing.cozy / 2;
}, function(props) {
    return props.theme.spacing.cozy;
});
var RepurchaseImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d980fce7-3"
})(_templateObject3());
var InlineContainer = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d980fce7-4"
})(_templateObject4(), function(props) {
    return props.theme.spacing.comfortable;
}, function(props) {
    return props.theme.spacing.comfortable;
}, InfoContainer);
var StyledOverlay = styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d980fce7-5"
})(_templateObject5(), function(props) {
    return props.theme.colors.white70;
});
var StyledCounter = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(_components__WEBPACK_IMPORTED_MODULE_8__/* .Counter */ .AT).withConfig({
    componentId: "sc-d980fce7-6"
})(_templateObject6());
var StyledCounterError = (0,styled_components__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP)(_components__WEBPACK_IMPORTED_MODULE_8__/* .Counter.Error */ .AT.Error).withConfig({
    componentId: "sc-d980fce7-7"
})(_templateObject7());
var selectItemUrlMap = {
    "mas-comprados": _utils_constants__WEBPACK_IMPORTED_MODULE_16__/* .analyticsItemListContexts.MOST_PURCHASED_PRODUCTS */ .LO.MOST_PURCHASED_PRODUCTS,
    "ultimo-pedido": _utils_constants__WEBPACK_IMPORTED_MODULE_16__/* .analyticsItemListContexts.LAST_ORDER */ .LO.LAST_ORDER
};
function getPurchasedTimesText(purchasedTimes) {
    return purchasedTimes ? "En ".concat(purchasedTimes, " pedido").concat(purchasedTimes > 1 ? "s" : "") : null;
}
function RepurchaseLineItemImage(props) {
    var isOutOfStock = props.isOutOfStock, src = props.src, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(props, [
        "isOutOfStock",
        "src"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ImageContainer, {
        children: [
            isOutOfStock && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledOverlay, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                    className: "text-center text-xs font-semibold",
                    children: [
                        "Fuera de ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                        " stock"
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_truck_image__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({
                height: _truck_theme__WEBPACK_IMPORTED_MODULE_14__/* ["default"].spacing.cozy */ .Z.spacing.cozy * 9,
                width: _truck_theme__WEBPACK_IMPORTED_MODULE_14__/* ["default"].spacing.cozy */ .Z.spacing.cozy * 9,
                src: _utils__WEBPACK_IMPORTED_MODULE_15__/* .cloudinary.applyTransformations */ .nl.applyTransformations(src !== null && src !== void 0 ? src : _utils_constants__WEBPACK_IMPORTED_MODULE_16__/* .images.PRODUCT_PLACEHOLDER */ .Wc.PRODUCT_PLACEHOLDER, _utils_constants__WEBPACK_IMPORTED_MODULE_16__/* .transformations.TINY_PRODUCT */ .S7.TINY_PRODUCT)
            }, rest))
        ]
    });
}
function RepurchaseLineItemCounter(props) {
    var ref;
    var isOutOfStock = props.isOutOfStock, fieldName = props.fieldName, counterMaxValue = props.counterMaxValue, counterMinValue = props.counterMinValue, counterMaxMessage = props.counterMaxMessage, catalogProduct = props.catalogProduct;
    var currentLineItemField = (0,react_final_form__WEBPACK_IMPORTED_MODULE_3__/* .useField */ .U$)(fieldName);
    var hasUnits = (0,toggled__WEBPACK_IMPORTED_MODULE_6__/* .useFlag */ .P5)(_utils_constants__WEBPACK_IMPORTED_MODULE_16__/* .flags.UNITS */ .id.UNITS);
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_2__.useState({
        isOpen: false,
        errorMessage: null
    }), 2), counterState = ref1[0], setCounterState = ref1[1];
    var onCounterOpen = function() {
        setCounterState(function(prevState) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, prevState), {
                isOpen: true
            });
        });
    };
    var onCounterClose = function() {
        setCounterState(function(prevState) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, prevState), {
                isOpen: false
            });
        });
    };
    var onCounterError = function(error) {
        setCounterState(function(prevState) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, prevState), {
                errorMessage: error
            });
        });
    };
    if (isOutOfStock) {
        return null;
    }
    var counterCommonProps = {
        maxMessage: counterMaxMessage,
        maxValue: counterMaxValue,
        minValue: counterMinValue,
        jumpFactor: catalogProduct.jumpFactor,
        allowZeroToEliminate: true,
        value: (0,lodash__WEBPACK_IMPORTED_MODULE_4__.isNumber)(currentLineItemField.input.value) ? currentLineItemField.input.value : 0,
        onError: onCounterError,
        onOpen: onCounterOpen,
        onClose: onCounterClose,
        onChange: (0,lodash__WEBPACK_IMPORTED_MODULE_4__.debounce)(function(value) {
            currentLineItemField.input.onChange(value);
        }, 200)
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            counterState.isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledOverlay, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CounterContainer, {
                children: [
                    !hasUnits ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCounter, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, counterCommonProps)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_unit_tooltip__WEBPACK_IMPORTED_MODULE_10__/* .UnitTooltip */ .X, {
                        visible: counterState.isOpen && currentLineItemField.input.value > 0,
                        duration: _components_product_shared__WEBPACK_IMPORTED_MODULE_9__/* .unitTooltipDuration */ .OD,
                        salesUnitFactor: catalogProduct.salesUnitFactor,
                        inventoryUnitCode: (ref = catalogProduct.inventoryUnit) === null || ref === void 0 ? void 0 : ref.code,
                        quantity: currentLineItemField.input.value,
                        zIndex: _variables__WEBPACK_IMPORTED_MODULE_17__/* .stack.mainHeader */ .kn.mainHeader - 1,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCounter, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, counterCommonProps))
                    }),
                    counterState.errorMessage && counterState.isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCounterError, {
                        message: counterState.errorMessage
                    })
                ]
            })
        ]
    });
}
function RepurchaseLineItem(props) {
    var catalogProduct = props.catalogProduct, purchasedTimes = props.purchasedTimes, fieldName = props.fieldName;
    var productUrl = "/p/".concat(catalogProduct.slug);
    var handleSalesQuantity = (0,_hooks__WEBPACK_IMPORTED_MODULE_11__/* .useSalesQuantity */ .FY)().handleSalesQuantity;
    var showSkuLabelFeature = (0,toggled__WEBPACK_IMPORTED_MODULE_6__/* .useFeature */ .SS)(_utils_constants__WEBPACK_IMPORTED_MODULE_16__/* .flags.SHOW_SKU_LABEL */ .id.SHOW_SKU_LABEL);
    var purchasedTimesText = getPurchasedTimesText(purchasedTimes);
    var ref = handleSalesQuantity({
        maximumSalesQuantity: catalogProduct.maximumSalesQuantity,
        minimumSalesQuantity: catalogProduct.minimumSalesQuantity,
        stock: catalogProduct.stock
    }), counterMaxValue = ref.counterMaxValue, counterMinValue = ref.counterMinValue, stock = ref.stock, counterMaxMessage = ref.counterMaxMessage;
    var canJumpAtLeastOnce = (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .validateIfCanJumpOnce */ .Xw)(catalogProduct.jumpFactor, counterMinValue, counterMaxValue);
    var maxValue = (0,_hooks_use_counter__WEBPACK_IMPORTED_MODULE_12__/* .getQuantityRange */ .t)({
        minValue: counterMinValue,
        maxValue: counterMaxValue,
        jumpFactor: catalogProduct.jumpFactor,
        allowZeroToEliminate: true
    }).maxValue;
    var realStock = Number(stock !== null && stock !== void 0 ? stock : catalogProduct.stock);
    var stockToDisplay = counterMaxValue ? maxValue : realStock;
    var isOutOfStock = realStock <= 0 || !canJumpAtLeastOnce;
    var lineItemQuantity = (0,react_final_form__WEBPACK_IMPORTED_MODULE_3__/* .useField */ .U$)(fieldName).input.value;
    var price = (0,_components_product_shared__WEBPACK_IMPORTED_MODULE_9__/* .getPriceFromTier */ .AZ)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, catalogProduct), {
        quantity: lineItemQuantity
    }));
    var triggerAnalyticsSelectItemEvent = function() {
        var currentPath = window.location.pathname.split("/")[2];
        var currentContext = selectItemUrlMap[currentPath];
        var analyticsProduct = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, catalogProduct), {
            pricing: {
                price: price
            },
            category: catalogProduct.categories[0]
        });
        _analytics__WEBPACK_IMPORTED_MODULE_7__/* .analytics.selectItem */ .co.selectItem(analyticsProduct, currentContext);
    };
    var showProductStock = (0,toggled__WEBPACK_IMPORTED_MODULE_6__/* .useFeature */ .SS)(_utils_constants__WEBPACK_IMPORTED_MODULE_16__/* .flags.SHOW_PRODUCT_STOCK */ .id.SHOW_PRODUCT_STOCK);
    var handleStock = (0,toggled__WEBPACK_IMPORTED_MODULE_6__/* .useFeature */ .SS)(_utils_constants__WEBPACK_IMPORTED_MODULE_16__/* .flags.HANDLE_STOCK */ .id.HANDLE_STOCK);
    var shouldShowStock = showProductStock && handleStock && realStock > 0 && canJumpAtLeastOnce;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(InlineContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RepurchaseImageContainer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                    href: productUrl,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                        onClick: triggerAnalyticsSelectItemEvent,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RepurchaseLineItemImage, {
                            isOutOfStock: isOutOfStock,
                            src: catalogProduct.photo
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "flex flex-col justify-center gap-1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                        passHref: true,
                        href: productUrl,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            className: "truncate",
                            onClick: triggerAnalyticsSelectItemEvent,
                            children: catalogProduct.name
                        })
                    }),
                    catalogProduct.presentation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                        className: "truncate text-xs text-secondary",
                        children: catalogProduct.presentation
                    }),
                    catalogProduct.attributesSummary && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                        className: "truncate text-xs text-tertiary",
                        children: catalogProduct.attributesSummary
                    }),
                    showSkuLabelFeature && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                        className: "truncate text-xs text-tertiary",
                        children: [
                            "SKU: ",
                            catalogProduct.sku
                        ]
                    }),
                    shouldShowStock && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                        className: "text-xs text-green-600",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                className: "text-xs font-semibold",
                                children: stockToDisplay > 9999 ? "+9999" : stockToDisplay
                            }),
                            " en stock"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_8__/* .Price */ .tA, {
                        value: price,
                        oldValue: catalogProduct.oldPrice,
                        isTaxExempt: catalogProduct.isTaxExemptPrice,
                        tierPricing: catalogProduct.tierPricing,
                        allowTaxLabel: true,
                        allowDiscountLabel: true
                    }),
                    purchasedTimesText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        className: "text-xs text-secondary",
                        children: purchasedTimesText
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RepurchaseLineItemCounter, {
                isOutOfStock: isOutOfStock,
                fieldName: fieldName,
                counterMaxValue: counterMaxValue,
                counterMinValue: counterMinValue,
                counterMaxMessage: counterMaxMessage,
                catalogProduct: catalogProduct
            })
        ]
    });
}


/***/ }),

/***/ 51858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ useRepurchaseOnSubmit; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/index.ts + 31 modules
var hooks = __webpack_require__(81251);
// EXTERNAL MODULE: ./src/utils/index.ts + 24 modules
var utils = __webpack_require__(90644);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/index.ts + 138 modules
var components = __webpack_require__(36357);
// EXTERNAL MODULE: ./src/truck/button/index.tsx + 2 modules
var truck_button = __webpack_require__(48721);
// EXTERNAL MODULE: ./src/truck/checkbox/index.tsx + 1 modules
var truck_checkbox = __webpack_require__(79412);
// EXTERNAL MODULE: ./src/truck/theme.ts
var theme = __webpack_require__(78904);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
;// CONCATENATED MODULE: ./src/screens/repurchase/dialog/index.tsx












var REPURCHASE_DIALOG_CHECKBOX_ID = "repurchase-dialog-checkbox";
function RepurchaseDialog(props) {
    var onAccept = props.onAccept, rest = (0,_object_without_properties/* default */.Z)(props, [
        "onAccept"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isChecked = ref[0], setIsChecked = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Dialog */.Vq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Dialog.Header */.Vq.Header, {
            closable: true
        }),
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Dialog.Content */.Vq.Content, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Message */.v0, {
                    title: "Tu lista de productos en el carrito",
                    content: "Los productos que agregues y se encuentren en tu carrito ser\xe1n remplazados con los nuevos valores.",
                    imageSrc: constants/* images.ILLUSTRATION_SHOPPING_CART */.Wc.ILLUSTRATION_SHOPPING_CART
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_checkbox/* default */.Z, {
                    id: REPURCHASE_DIALOG_CHECKBOX_ID,
                    style: {
                        marginTop: theme/* default.spacing.relaxed */.Z.spacing.relaxed
                    },
                    checked: isChecked,
                    onChange: function(e) {
                        return setIsChecked(e.target.checked);
                    },
                    children: "No mostrar de nuevo"
                })
            ]
        }),
        accept: /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_button/* default */.Z, {
            color: "secondary",
            onClick: function() {
                utils/* storage.set */.tO.set(REPURCHASE_DIALOG_CHECKBOX_ID, isChecked);
                onAccept();
            },
            children: "Agregar al carrito"
        }),
        cancel: /*#__PURE__*/ (0,jsx_runtime.jsx)(truck_button/* default.Ghost */.Z.Ghost, {
            color: "grayDark",
            onClick: rest.onClose,
            children: "Cancelar"
        })
    }));
}

;// CONCATENATED MODULE: ./src/screens/repurchase/use-on-submit/index.ts




function useRepurchaseOnSubmit(onSubmit) {
    var modalManager = (0,hooks/* useModalManager */.$C)();
    var onSubmitRef = react.useRef();
    function openConfirmDialog() {
        modalManager.openModal(RepurchaseDialog, {
            onClose: function() {
                onSubmitRef.current = openConfirmDialog;
                modalManager.closeModal();
            },
            onAccept: function() {
                onSubmitRef.current = onSubmit;
                document.getElementById("repurchase-form").dispatchEvent(new Event("submit", {
                    cancelable: true,
                    bubbles: true
                }));
                modalManager.closeModal();
            }
        });
    }
    react.useEffect(function() {
        var cannotShowConfirmDialog = utils/* storage.get */.tO.get(REPURCHASE_DIALOG_CHECKBOX_ID);
        if (cannotShowConfirmDialog) {
            onSubmitRef.current = onSubmit;
        } else {
            onSubmitRef.current = openConfirmDialog;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return function(formValues) {
        return onSubmitRef.current(formValues);
    };
}


/***/ })

}]);